<div class="card mt-4 mb-4 mb-xxl-10">
    <div class="card-header">
        <div class="card-title">
            <h3>{{ isCreateUser() ? 'Add New User' : userTitle() }}</h3>
        </div>
    </div>
    <div class="card-body px-0 py-0">
        <mat-tab-group [(selectedIndex)]="this.selectedTab" (selectedIndexChange)="onTabChange($event)">
            <mat-tab>
                <ng-template mat-tab-label> 
                    <h3 class="fw-bold text-gray-900 mb-0">User Details</h3>
                </ng-template>
                @if (selectedTab === 0) {
                     <app-user-details [userDetailsForm]="userDetailsForm" [userId]="userId()" [isTabChange]="isTabChange()" [isCreateUser]="isCreateUser()"
                    (userDetailsSubmitEmitter)="onSaveHandler($event)" (cancelEmitter)="onCancel($event)" (isAdminCompany)="onAdminCompanySelected($event)"></app-user-details>
                }
            </mat-tab>
            @if(!isAdminCompanySelected()){
            <mat-tab [disabled]="this.isCreateUser()">
                <ng-template mat-tab-label> 
                    <h3 class="fw-bold text-gray-900 mb-0">Product & SL Details</h3>
                </ng-template>
                @if (selectedTab === 1) {
                    <app-product-details></app-product-details>
                }
            </mat-tab>
        }
            <mat-tab [disabled]="this.isCreateUser()">
                <ng-template mat-tab-label> 
                    <h3 class="fw-bold text-gray-900 mb-0">User Config</h3>
                </ng-template>
                <!-- @if (selectedTab === 2) { -->
                    <app-user-config [userConfigForm]="userConfigForm" [userId]="userId()" [isCreateUser]="isCreateUser()"
                    (userConfigSubmitEmitter)="onUserConfigSubmit($event)" (cancelEmitter)="onCancel($event)" 
                    (setupLinkEmitter)="onSetupLinkAction($event)" (resetLinkEmitter)="onResetLinkAction($event)"></app-user-config>
                <!-- } -->
            </mat-tab>
        </mat-tab-group>
    </div>
</div>